<div style="padding: 2rem;">

  <!-- Page header -->
  <div style="margin-bottom: 1.75rem;">
    <h1 style="font-size: 1.5rem; font-weight: 700; color: #1e293b; margin: 0 0 0.25rem;">
      Tarification
    </h1>
    <p style="font-size: 0.875rem; color: #64748b; margin: 0;">Gestion des tarifications</p>
  </div>

  <!-- Main card -->
  <div class="afri-card">

    <!-- Tabs -->
    <ul class="afri-tabs nav" style="padding: 0 1.5rem;">
      <li class="nav-item">
        <a role="tab" class="nav-link active" id="tab-c1-0" data-bs-toggle="tab" href="#tab-animated1-0" aria-selected="true">
          <span class="nav-text">Boutique</span>
        </a>
      </li>
      <li class="nav-item">
        <a role="tab" class="nav-link" id="tab-c1-1" data-bs-toggle="tab" href="#tab-animated1-1" aria-selected="false">
          <span class="nav-text">Restaurant</span>
        </a>
      </li>
    </ul>

    <div class="tab-content">

      <!-- Tab 1: Boutique -->
      <div class="tab-pane active" id="tab-animated1-0" role="tabpanel">

        <!-- Card header: actions + count -->
        <div class="afri-card-header">
          <div class="flex items-center gap-2 flex-wrap" *ngIf="buttonsPermission">
            <button *ngIf="buttonsPermission.add" (click)="add(addContent)" class="btn-afri-primary">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
              </svg>
              Ajouter
            </button>
            <button *ngIf="buttonsPermission.show" (click)="show(showContent)" class="btn-afri-outline">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
              </svg>
              Consulter
            </button>
            <button *ngIf="buttonsPermission.edit" (click)="edit(editContent)" class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d;">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
              </svg>
              Éditer
            </button>
            <button *ngIf="buttonsPermission.delete" (click)="delete()" class="btn-afri-danger">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
              Supprimer
            </button>
          </div>
          <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
            <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ data!.length }}</span>
            élément(s)
            <app-loading [isVisible]="loading2"></app-loading>
          </div>
        </div>

        <!-- Table -->
        <div style="overflow-x: auto;">
          <table class="afri-table">
            <thead>
              <tr>
                <th style="width: 52px; padding-left: 1.5rem;">#</th>
                <th>Montant mini</th>
                <th>Montant max</th>
                <th>Taux</th>
                <th>Pays</th>
                <th>Ajouté par</th>
                <th>Modifié par</th>
                <th>Ajouté le</th>
                <th>Modifié le</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let d of data | paginate: {
                    id: 'ngxP1',
                    itemsPerPage: pg.pageSize,
                    currentPage: pg.p,
                    totalItems: pg.total
                  } | sampleSearch:search_text"
                  [style.background]="selected_data?.id === d.id ? '#f0f4ff' : ''">
                <td style="padding-left: 1.5rem;">
                  <input (click)="checked(d)" type="radio" name="selectRow"
                         style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
                </td>
                <td>{{d.mini}}</td>
                <td>{{d.maxi}}</td>
                <td>{{d.value}}</td>
                <td>{{d.country?.name}}</td>
                <td>{{d.creator?.lastname}} {{d.creator?.firstname}}</td>
                <td>{{d.updator?.lastname}} {{d.updator?.firstname}}</td>
                <td>{{d.created_at | date:"dd/MM/yyyy"}}</td>
                <td>{{d.updated_at | date:"dd/MM/yyyy"}}</td>
              </tr>

              <tr *ngIf="data.length === 0 && !loading2">
                <td colspan="9" style="padding: 4rem 1.25rem; text-align: center;">
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                    <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                    <p style="margin: 0; font-weight: 500;">Aucun élément trouvé</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div style="padding: 0.5rem 1.5rem 1.25rem;">
          <pagination-controls
            id="ngxP1"
            (pageChange)="getPage($event)"
            [maxSize]="9"
            [directionLinks]="true"
            [autoHide]="true"
            [responsive]="true"
            [previousLabel]="'Précédent'"
            [nextLabel]="'Suivant'">
          </pagination-controls>
        </div>

      </div><!-- end tab 1 -->

      <!-- Tab 2: Restaurant -->
      <div class="tab-pane" id="tab-animated1-1" role="tabpanel">

        <!-- Card header: actions + count -->
        <div class="afri-card-header">
          <div class="flex items-center gap-2 flex-wrap" *ngIf="buttonsPermission">
            <button *ngIf="buttonsPermission.add" (click)="add(addContent)" class="btn-afri-primary">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
              </svg>
              Ajouter
            </button>
            <button *ngIf="buttonsPermission.show" (click)="show(showContent)" class="btn-afri-outline">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
              </svg>
              Consulter
            </button>
            <button *ngIf="buttonsPermission.edit" (click)="edit(editContent)" class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d;">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
              </svg>
              Éditer
            </button>
            <button *ngIf="buttonsPermission.delete" (click)="delete()" class="btn-afri-danger">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
              Supprimer
            </button>
          </div>
          <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
            <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ data2!.length }}</span>
            élément(s)
            <app-loading [isVisible]="loading2"></app-loading>
          </div>
        </div>

        <!-- Table -->
        <div style="overflow-x: auto;">
          <table class="afri-table">
            <thead>
              <tr>
                <th style="width: 52px; padding-left: 1.5rem;">#</th>
                <th>Montant mini</th>
                <th>Montant max</th>
                <th>Taux</th>
                <th>Pays</th>
                <th>Ajouté par</th>
                <th>Modifié par</th>
                <th>Ajouté le</th>
                <th>Modifié le</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let d of data2 | paginate: {
                    id: 'ngxP2',
                    itemsPerPage: pg2.pageSize,
                    currentPage: pg2.p,
                    totalItems: pg2.total
                  } | sampleSearch:search_text"
                  [style.background]="selected_data?.id === d.id ? '#f0f4ff' : ''">
                <td style="padding-left: 1.5rem;">
                  <input (click)="checked(d)" type="radio" name="selectRow"
                         style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
                </td>
                <td>{{d.mini}}</td>
                <td>{{d.maxi}}</td>
                <td>{{d.value}}</td>
                <td>{{d.country?.name}}</td>
                <td>{{d.creator?.lastname}} {{d.creator?.firstname}}</td>
                <td>{{d.updator?.lastname}} {{d.updator?.firstname}}</td>
                <td>{{d.created_at | date:"dd/MM/yyyy"}}</td>
                <td>{{d.updated_at | date:"dd/MM/yyyy"}}</td>
              </tr>

              <tr *ngIf="data2.length === 0 && !loading2">
                <td colspan="9" style="padding: 4rem 1.25rem; text-align: center;">
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                    <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                    <p style="margin: 0; font-weight: 500;">Aucun élément trouvé</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div style="padding: 0.5rem 1.5rem 1.25rem;">
          <pagination-controls
            id="ngxP2"
            (pageChange)="getPage2($event)"
            [maxSize]="9"
            [directionLinks]="true"
            [autoHide]="true"
            [responsive]="true"
            [previousLabel]="'Précédent'"
            [nextLabel]="'Suivant'">
          </pagination-controls>
        </div>

      </div><!-- end tab 2 -->

    </div><!-- end tab-content -->

  </div><!-- end card -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
  <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Enregistrer une tarification</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Type <span class="text-danger ml-2">(*)</span></label>
          <select class="afri-input" ngModel name="type">
            <option value="shop">Boutique</option>
            <option value="restaurant">Restaurant</option>
            <option value="used">Occasion</option>
          </select>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Montant Minimal <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="mini" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Montant Maximal <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="maxi" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Pourcentage d'argent à retirer (%) <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="value" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Code du pays <span class="text-danger ml-2">(*)</span></label>
          <select name="country" class="afri-input" ngModel>
            <option *ngFor="let c of countries" [value]="c.code">{{c.name}}</option>
          </select>
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="addForm.invalid">Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #editContent let-c="close" let-d="dismiss">
  <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Modifier une tarification</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Type <span class="text-danger ml-2">(*)</span></label>
          <select class="afri-input" [(ngModel)]="selected_data.type" name="type">
            <option value="shop">Boutique</option>
            <option value="restaurant">Restaurant</option>
            <option value="used">Occasion</option>
          </select>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Montant Minimal <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="mini" class="afri-input" [(ngModel)]="selected_data.mini">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Montant Maximal <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="maxi" class="afri-input" [(ngModel)]="selected_data.maxi">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Pourcentage d'argent à retirer (%) <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="value" class="afri-input" [(ngModel)]="selected_data.value">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Code du pays <span class="text-danger ml-2">(*)</span></label>
          <select name="country" class="afri-input" [(ngModel)]="countryCode">
            <option *ngFor="let c of countries" [value]="c.code">{{c.name}}</option>
          </select>
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="editForm.invalid">Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #showContent let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="table-responsive table-card">
      <table class="table table-borderless align-middle mb-0">
        <tbody></tbody>
      </table>
    </div>
  </div>
</ng-template>
